import script from "./Delivery.vue?vue&type=script&setup=true&lang=js"
export * from "./Delivery.vue?vue&type=script&setup=true&lang=js"

import "./Delivery.vue?vue&type=style&index=0&id=30355756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30355756"]])

export default __exports__